import React, { Component } from 'react';
import { RandomizedUserBadgeColors } from '../constants';
import RadioBtnUnchecked from '../assets/icons/radio_button_unchecked.svg';
import RadioBtnchecked from '../assets/icons/radio_button_checked.svg';
import ThemedButoons from '../CommonComponents/ThemedButtons';
import crossImg from '../assets/icons/close-smallSize.svg';
import AddQueue from '../assets/icons/add.svg';
import SearchBar from '../CommonComponents/SearchBar';
import SearchIcon from '../assets/icons/search.svg';
import { api } from '../utils';
import CheckBox from '../assets/icons/check_box_unchecked.svg';
import SelectedCheckBox from '../assets/icons/check_box_checked.svg';

type Props = {
  userDetails: { username: string; email: string; roltype: string }[];
  onCancel: Function;
  onSave: Function;
  origin: string;
  botId: string;
  editedAgentId: string;
};

type State = {
  roleType: string;
  addQueues: boolean;
  searchTerm: string;
  selectedQueueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  queueList: {
    queueId: number;
    queueName: string;
    check: boolean;
  }[];
  agentRole: boolean;
};

export default class EditUserModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.saveRole = this.saveRole.bind(this);
    this.addQueueList = this.addQueueList.bind(this);
  }
  setInitialState(): State {
    return {
      roleType: 'Agent',
      addQueues: false,
      searchTerm: '',
      selectedQueueList: [],
      queueList: [],
      agentRole: false,
    };
  }
  componentDidMount() {
    if (this.props.userDetails[0].roltype) {
      this.setState({
        roleType: this.props.userDetails[0].roltype,
      });
    }
  
    api(
      `getQueueNamesAndIdsPerAgent?botId=${encodeURIComponent(
        this.props.botId
      )}&agentId=${this.props.editedAgentId}`
    ).then((res) => {
      res.map((data: any) => {
        this.setState((prevState) => ({
          selectedQueueList: [
            {
              queueId: data.queueId,
              queueName: data.queueName,
              check: true,
            },
          ],
          queueList: prevState.queueList.map((obj) =>
            obj.queueId === data.queueId ? Object.assign(obj, { check: !obj.check }) : obj
          ),
        }));
      });
      this.setState((prevState) => ({
        selectedQueueList: res.map((data: any) => {
          return {
            queueId: data.queueId,
            queueName: data.queueName,
            check: true,
          };
        }),
      }));
    });
  }
  get queueDetails() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    return this.state.queueList.filter(
      (filterData) => filterData.queueName.toLowerCase().indexOf(searchTerm) >= 0
    );
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (prevProps.userDetails[0].roltype !== this.props.userDetails[0].roltype) {
      this.setState({
        roleType: this.props.userDetails[0].roltype,
      });
    }
  }
  saveRole() {
    const queueIds: any = [];
    this.state.selectedQueueList.map((data: any) => {
      if (data.check === true) {
        queueIds.push(data.queueId);
      }
    });
    let data = {
      // botId: encodeURIComponent(this.props.botId),
      botId:this.props.botId,
      agentId: this.props.editedAgentId,
      roleName: this.state.roleType,
      currentRoleName: this.props.origin,
    };
    api('editRole', 'POST', data).then((res) => {
      this.props.onSave(this.state.roleType, res.msg);
    });
  }
  addQueueList() {
    const list = this.state.queueList.filter((data) => data.check === true);
    this.setState({
      selectedQueueList: list,
    });
  }
  removeQueue(queueId: any) {
    this.setState((prevState) => ({
      selectedQueueList: prevState.selectedQueueList.map((obj) =>
        obj.queueId === queueId ? Object.assign(obj, { check: !obj.check }) : obj
      ),
    }));
  }

  render() {
    return (
      <div className='edit-role-w'>
        <div className='single-line-alignment'>
          <div
            style={{
              backgroundColor:
                RandomizedUserBadgeColors[
                  this.props.userDetails[0].username[0]
                    .toLocaleLowerCase()
                    .charCodeAt(0) % 97
                ],
            }}
            className='user-badge user-badge-sub'>
            {this.props.userDetails[0].username[0]}
          </div>
          <div>{this.props.userDetails[0].username}</div>
          <div style={{ marginLeft: '5px' }}>({this.props.userDetails[0].email})</div>
        </div>

        <>
          <div className='single-line-alignment top-alignment'>
            <img
              src={this.state.roleType === 'Admin' ? RadioBtnchecked : RadioBtnUnchecked}
              onClick={() => {
                this.setState({
                  roleType: 'Admin',
                });
              }}
              alt='radio-btn'
              style={{ width: '20px', height: '20px' }}
            />
            <div style={{ marginLeft: '10px' }}>
              <span style={{ fontSize: '14px' }}>Admin</span>
              <div className='role-info'>
                Access only to bot configurations and analytics in Hybrid Chat{' '}
              </div>
            </div>
          </div>
          <div className='single-line-alignment top-alignment'>
            <img
              src={
                this.state.roleType === 'Analyst' ? RadioBtnchecked : RadioBtnUnchecked
              }
              alt='radio-btn'
              style={{ width: '20px', height: '20px' }}
              onClick={() => {
                this.setState({
                  roleType: 'Analyst',
                });
              }}
            />
            <div style={{ marginLeft: '10px' }}>
              <span style={{ fontSize: '14px' }}>Analyst</span>
              <div className='role-info'>Access only to Hybrid Chat analytics</div>
            </div>
          </div>
          <div className='single-line-alignment top-alignment'>
            <img
              src={this.state.roleType === 'Agent' ? RadioBtnchecked : RadioBtnUnchecked}
              alt='radio-btn'
              style={{ width: '20px', height: '20px' }}
              onClick={() => {
                this.setState({
                  // agentRole: !this.state.agentRole,
                  roleType: 'Agent',
                });
              }}
            />
            <div style={{ marginLeft: '10px' }}>
              <span style={{ fontSize: '14px' }}>Agent</span>
              <div style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '10px' }}>
                Access only to chat screens & bot queues{' '}
              </div>
            </div>
          </div>
        </>

        {this.state.addQueues && (
          <div className='add-team-queues-w team-queue'>
            <div className='add-team-queues'>
              <SearchBar
                placeholder='Search queues'
                importedImg='yes'
                icon={SearchIcon}
                onSearch={(term: any) => {
                  this.setState({
                    searchTerm: term,
                  });
                }}
              />
              <div style={{ overflowY: 'auto', maxHeight: '200px' }}>
                {this.queueDetails.map((queueData, i) => {
                  return (
                    <div
                      key={i}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '7px',
                      }}>
                      <img
                        src={queueData.check ? SelectedCheckBox : CheckBox}
                        onClick={() => {
                          this.setState((prevState) => ({
                            queueList: prevState.queueList.map((obj) =>
                              obj.queueId === queueData.queueId
                                ? Object.assign(obj, { check: !queueData.check })
                                : obj
                            ),
                          }));
                        }}
                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                      />

                      <div style={{ marginLeft: '10px' }}>{queueData.queueName}</div>
                    </div>
                  );
                })}
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '10px 0px 10px 0px',
                }}>
                <ThemedButoons
                  theme='4'
                  title='Done'
                  onClick={() => {
                    this.addQueueList();
                    this.setState({
                      addQueues: !this.state.addQueues,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div className='btn-wrapper'>
          <div style={{ marginRight: '10px' }}>
            <ThemedButoons
              title='Cancel'
              theme='3'
              onClick={() => {
                this.props.onCancel();
              }}
            />
          </div>
          <ThemedButoons
            title='Save'
            theme='4'
            onClick={() => {
              this.saveRole();
            }}
            disabled={this.props.userDetails[0].roltype !== this.state.roleType}
          />
        </div>
      </div>
    );
  }
}
